import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {BlockBaseComponent} from "../scene-blocks/block-base/block-base.component";
import {AppService, CommonService, LocalStoreService, SceneService, StoreSelectorsService} from "../../../services";
import {compareIds, isNullOrUndefOrEmpty} from "../../../common";
import {FormBuilder, FormGroup} from "@angular/forms";
import {actionCRUDRecord, actionUpdateScheduleItem} from "../../../store/actions/user.actions";
import {EnumWizardUpgradeToasts, ISchedule, IUser} from "../../../interfaces";
import {DialogNewScheduleComponent} from "../../../components/dialog-new-schedule/dialog-new-schedule.component";
import {take} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {TranslocoService} from "@ngneat/transloco";
import {Lib} from "../../../../libs/Lib";

@Component({
    selector: 'app-block-scheduler',
    templateUrl: './block-scheduler.component.html',
    styleUrls: ['./block-scheduler.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockSchedulerComponent extends BlockBaseComponent {

    public schedulerName = '';
    formScheduleProps: FormGroup;
    selectedScheduler: ISchedule;
    schedulers: ISchedule[];
    disableMode = false;
    user: IUser;

    constructor(public override storeSelector: StoreSelectorsService,
                private fb: FormBuilder,
                public override dialog: MatDialog,
                private toastr: ToastrService,
                public commonService: CommonService,
                private sceneService: SceneService,
                private appService: AppService,
                private translocoService: TranslocoService,
                public cd: ChangeDetectorRef,
                protected override localStoreService: LocalStoreService
    ) {
        super(storeSelector, dialog);
        this.formScheduleProps = this.fb.group({
            schedule_name: [''],
            description: [''],
            event_name: ['']
        });
    }

    override componentInit() {
        super.componentInit();
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                })
        );
        this.cod(
            this.storeSelector.getSchedules()
                .subscribe((a) => {
                    this.schedulers = a;
                    if (isNullOrUndefOrEmpty(this.sceneItem.Data[0].Schedule[0])) {
                        this.applyDisableMode();
                        return;
                    }
                    const sched = a.filter((v) => compareIds(v.schedule_id, this.sceneItem.Data[0].Schedule[0].$.id));
                    if (sched.length === 1) {
                        this.applyEnableMode();
                        this.selectedScheduler = sched[0];
                        this.resetSchedulerFormSetting(this.selectedScheduler);
                        this.cd.markForCheck();
                    } else {
                        this.applyDisableMode();
                    }
                })
        );
    }

    createNewScheduler() {
        if (Lib.IsFreeAccount(this.user) && this.schedulers.length >= 1) {
            this.appService.openWizardUpgradeDialog(EnumWizardUpgradeToasts.REACHED_LIMIT_OF_FEATURE);
            return;
        }
        // open dialog and allow user to name / desc of new schedule
        const newDlg = this.dialog.open(DialogNewScheduleComponent, {data: {showJump: true}});
        this.cod(
            newDlg.afterClosed()
                .pipe(take(1))
                .subscribe((data: ISchedule) => {
                    if (data) {
                        this.commonService.addSchedule(data);
                    }
                })
        );
    }

    applyDisableMode() {
        this.formScheduleProps.get('description').disable();
        this.disableMode = true;
        this.cd.markForCheck();
    }

    applyEnableMode() {
        this.formScheduleProps.get('description').enable();
        this.disableMode = false;
        this.cd.markForCheck();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.cd.markForCheck();
        // super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [];
    }

    private resetSchedulerFormSetting(i_schedule) {
        this.formScheduleProps.patchValue(
            {
                schedule_name: i_schedule,
                description: i_schedule.description,
                event_name: i_schedule.event_name
            }, {emitEvent: false, onlySelf: true});
        this.cd.detectChanges();
    }

    jumpToSchedulers() {
        this.sceneService.jumpToSchedulers(this.selectedScheduler.schedule_id);
    }

    changeDescription(e) {
        this.updateScheduler(this.selectedScheduler.schedule_id, this.selectedScheduler.schedule_name, e.target.value, this.selectedScheduler.event_name);
    }

    updateScheduler(id, schedule_name, description, event_name) {
        this.storeSelector.dispatch(actionUpdateScheduleItem({
            schedule_id: id,
            values: [
                {key: 'schedule_name', value: schedule_name},
                {key: 'description', value: description},
                {key: 'event_name', value: event_name},
            ]
        }));
        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command: 'update',
                primary: 'schedule_id',
                table: 'schedules',
                id,
                body: {event_name, description, schedule_name}
            }
        }));
    }

    selectSchedulerId(e) {
        this.selectedScheduler = e.value;
        this.resetSchedulerFormSetting(this.selectedScheduler);
        this.applyEnableMode();
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'id',
                value: this.selectedScheduler.schedule_id,
                storePath: 'Data[0].Schedule[0].$'
            }]
        });
    }

    updateSchedulerDetails(schedule: ISchedule) {
        this.storeSelector.dispatch(actionUpdateScheduleItem({
            schedule_id: schedule.schedule_id,
            values: [
                {key: 'schedule_name', value: schedule.schedule_name},
                {key: 'description', value: schedule.description},
                {key: 'event_name', value: schedule.event_name},
            ]
        }));
        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command: 'update',
                primary: 'schedule_id',
                table: 'schedules',
                id: schedule.schedule_id,
                body: {event_name: schedule.event_name, description: schedule.description, schedule_name: schedule.schedule_name}
            }
        }));
    }

}


// route to scheduler and select proper schedule
// this.localStoreService.setStorageValConfig('scheduledEnabled', '1');
// this.storeSelector.dispatch(actionSelectedSchedule({
//     scheduleSelection: {
//         scheduler: {
//             scheduleId: this.selectedScheduler.schedule_id,
//             unique: Math.random()
//         }
//     }
// }));
// this.router.navigateByUrl('/scheduler/editor');
